import { sendGoogleEvent, byWindowAction } from '@html/_common/utils';

export default function setupMapImageBlock(mobileWidthMaximum, tabletWidthMaximum) {
  if (!mobileWidthMaximum || !tabletWidthMaximum) {
    throw new Error('setupMapImageBlock:: Please pass width boundaries to the function.');
  }

  const isInTabletWidth = (width) => width > mobileWidthMaximum && width <= tabletWidthMaximum;

  const isInMobileWidth = (width) => width <= mobileWidthMaximum;

  const IMAGE_SIZES = {
    mobile: '375x320',
    tablet: '768x320',
    desktop: '1171x320',
  };

  const $mapImage = $('.js-ao-tour-map-image-block__map-image');

  $mapImage.on('click', () => {
    sendGoogleEvent(
      'Map',
      'Map clicked',
      'tdp_map_clicked',
      {
        ampEventName: 'tdp_map_clicked',
        tdp_map_clicked_modal: 'Open Map - TDP',
      },
    );
  });

  const getDeviceType = (width) => {
    let deviceType = null;

    if (isInMobileWidth(width)) {
      deviceType = 'mobile';
    } else if (isInTabletWidth(width)) {
      deviceType = 'tablet';
    } else {
      deviceType = 'desktop';
    }

    return deviceType;
  };

  const initResize = () => {
    byWindowAction(['resize'], () => {
      const currentPageWidth = $(window).width();

      const deviceType = getDeviceType(currentPageWidth);
      const imageSizeToUse = IMAGE_SIZES[deviceType];

      const currentImageUrl = $mapImage.data('src');

      // Example string: //cdn.tourradar.com/s3/map/1171x320/149288_f10e.png
      // RegEx matches part: /1171x320/
      // Replace that part with the new image size
      // eslint-disable-next-line prefer-regex-literals
      const regex = new RegExp('\\/\\d+x\\d+\\/');
      const newImageUrl = currentImageUrl.replace(regex, `/${imageSizeToUse}/`);

      $mapImage.attr('src', newImageUrl);
      $mapImage.data('src', newImageUrl);
    });
  };

  const initiate = () => {
    if (!$mapImage.length) {
      return;
    }

    initResize();
  };

  initiate();
}
